module.exports = __webpack_public_path__ + "img/10-lrn-spt-feat-ban-570.4bf40c06.svg";